import { TemplateChannel, TemplateContext, type TemplatePair } from '@fluenceur/types';
import { InvitationMethod } from '@/types/invitation';

// Generic, pair-keyed selection helpers now live next to the shared template
// components so the email composers can reuse them without importing across
// features. Re-exported here to keep existing invitation-flow imports stable.
export {
  attributableTemplateId,
  carryOverVariableValues,
  entriesForPair,
  pickDefaultEntry,
} from '@/components/templates/template-selection';

/**
 * Map a dashboard send mode to the (channel, context) pair that backs its
 * template library. Returns `null` for modes with no template library binding.
 *
 * - Direct message -> (instagram_dm, invitation)
 * - Comment -> (instagram_comment, invitation)
 * - Email -> (email, invitation)
 */
export const methodToPair = (method: InvitationMethod): TemplatePair | null => {
  switch (method) {
    case InvitationMethod.DIRECT_MESSAGE:
      return { channel: TemplateChannel.INSTAGRAM_DM, context: TemplateContext.INVITATION };
    case InvitationMethod.COMMENT:
      return { channel: TemplateChannel.INSTAGRAM_COMMENT, context: TemplateContext.INVITATION };
    case InvitationMethod.EMAIL:
      return { channel: TemplateChannel.EMAIL, context: TemplateContext.INVITATION };
    default:
      return null;
  }
};
